
import { useState } from 'react';
import { ALMData, TimeHorizon } from '../index';

export const useALMCalculations = (almData: ALMData, currentHorizons: TimeHorizon[]) => {
  // Calculate totals for each category and time horizon
  const calculateTotals = () => {
    const totals = {
      assets: {} as Record<string, number>,
      liabilities: {} as Record<string, number>,
      equity: {} as Record<string, number>,
      netPosition: {} as Record<string, number>
    };
    
    currentHorizons.forEach(horizon => {
      totals.assets[horizon.id] = almData.assets.reduce(
        (sum, asset) => sum + (asset.values[horizon.id] || 0), 0
      );
      
      totals.liabilities[horizon.id] = almData.liabilities.reduce(
        (sum, liability) => sum + (liability.values[horizon.id] || 0), 0
      );
      
      totals.equity[horizon.id] = almData.equity.reduce(
        (sum, equity) => sum + (equity.values[horizon.id] || 0), 0
      );
      
      totals.netPosition[horizon.id] = 
        totals.assets[horizon.id] + 
        totals.equity[horizon.id] - 
        totals.liabilities[horizon.id];
    });
    
    return totals;
  };

  return { calculateTotals };
};

export default useALMCalculations;
